import type { CaseData, TimelineItem } from '../types'

export const legacySymptomPrefix = 'legacy-symptom:'

function timeParts(value: string) {
  const match = value.match(/^(\d{4}-\d{2}-\d{2})(?:T(\d{2}:\d{2}))?/)
  return { date: match?.[1] || value.slice(0, 10), time: match?.[2] }
}

/**
 * Older imported records stored the current symptoms separately from the
 * editable timeline. Present those rows as ordinary timeline entries so the
 * guardian can update or remove them from the same editor.
 */
export function editableCaseTimeline(record: CaseData): TimelineItem[] {
  const linkedSymptomIds = new Set(record.timeline.map((item) => `symptom-${item.id}`))
  const legacySymptoms: TimelineItem[] = record.symptoms
    .filter((symptom) => !linkedSymptomIds.has(symptom.id))
    .map((symptom) => {
      const occurred = timeParts(symptom.startedAt)
      return {
        id: `${legacySymptomPrefix}${symptom.id}`,
        date: occurred.date,
        time: occurred.time,
        petIds: symptom.petIds,
        category: 'symptom',
        title: symptom.title,
        description: symptom.detail,
        source: symptom.source,
        severity: symptom.severity,
        blocks: [{ id: `legacy-block-${symptom.id}`, type: 'symptom', content: symptom.detail.ko, source: 'guardian_observation' }],
      }
    })

  return [...record.timeline, ...legacySymptoms]
}

